import React, { useEffect, useRef, useState } from "react";
import { DateRange } from "react-date-range";
import {
    format,
    subDays,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    subMonths,
} from "date-fns";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const DateFilter = ({ setDateForApi }) => {
    const dropdownRef = useRef(null);

    const [showDropdown, setShowDropdown] = useState(false);
    const [hasSelected, setHasSelected] = useState(false);

    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
    });

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleClear = () => {
        setHasSelected(false);

        setSelectionRange({
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        });

        setDateForApi({
            from: "",
            to: "",
        });

        setShowDropdown(false);
    };

    const setRange = (start, end) => {
        setSelectionRange({
            startDate: start,
            endDate: end,
            key: "selection",
        });

        setHasSelected(true);

        setDateForApi({
            from: format(start, "yyyy-MM-dd"),
            to: format(end, "yyyy-MM-dd"),
        });

        setShowDropdown(false);
    };

    const today = new Date();

    const quickRanges = [
        {
            label: "Today",
            onClick: () => setRange(today, today),
        },
        {
            label: "Yesterday",
            onClick: () => setRange(subDays(today, 1), subDays(today, 1)),
        },
        {
            label: "Last 7 Days",
            onClick: () => setRange(subDays(today, 6), today),
        },
        {
            label: "This Week",
            onClick: () => setRange(startOfWeek(today), endOfWeek(today)),
        },
        {
            label: "This Month",
            onClick: () => setRange(startOfMonth(today), endOfMonth(today)),
        },
        {
            label: "Last Month",
            onClick: () => {
                const lastMonth = subMonths(today, 1);
                setRange(startOfMonth(lastMonth), endOfMonth(lastMonth));
            },
        },
    ];

    return (
        <div className="position-relative mt-2" ref={dropdownRef}>
            <button
                type="button"
                className="btn d-flex align-items-center gap-2"
                onClick={() => setShowDropdown(!showDropdown)}
                style={{
                    background: "#36467d",
                    color: "#fff",
                    height: "46px",
                    minWidth: "240px",
                    borderRadius: "4px",
                }}
            >
                <i className="fa fa-calendar"></i>

                <span style={{ fontSize: "14px" }}>
                    {hasSelected
                        ? `${format(selectionRange.startDate, "dd MMM")} - ${format(
                              selectionRange.endDate,
                              "dd MMM"
                          )}`
                        : "Select Calendar Date"}
                </span>

                {hasSelected && (
                    <i
                        className="fa fa-trash ms-auto text-danger"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleClear();
                        }}
                    />
                )}
            </button>

            {showDropdown && (
                <div
                    className="position-absolute bg-white shadow"
                    style={{
                        top: "55px",
                        left: 0,
                        zIndex: 9999,
                        borderRadius: "12px",
                        overflow: "hidden",
                    }}
                >
                    <div className="d-flex">
                        <div style={{ width: "140px" }}>
                            {quickRanges.map((item, index) => (
                                <button
                                    key={index}
                                    className="btn w-100 text-start border-bottom rounded-0"
                                    onClick={item.onClick}
                                >
                                    {item.label}
                                </button>
                            ))}
                        </div>

                        <DateRange
                            editableDateInputs={false}
                            moveRangeOnFirstSelection={false}
                            ranges={[selectionRange]}
                            months={1}
                            direction="horizontal"
                            showDateDisplay={false}
                            onChange={(item) => {
                                const range = item.selection;

                                setSelectionRange(range);
                                setHasSelected(true);

                                if (
                                    range.startDate &&
                                    range.endDate &&
                                    range.startDate.getTime() !==
                                        range.endDate.getTime()
                                ) {
                                    setDateForApi({
                                        from: format(
                                            range.startDate,
                                            "yyyy-MM-dd"
                                        ),
                                        to: format(
                                            range.endDate,
                                            "yyyy-MM-dd"
                                        ),
                                    });

                                    setShowDropdown(false);
                                }
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default DateFilter;